import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const ContactForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    type: 'general',
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // TODO: 백엔드 API 연동 필요
    // POST /api/contact
    // Body: formData
    console.log('Contact form submitted:', formData);

    // 임시로 emailjs 활용 가능
    // emailjs.send('service_id', 'template_id', formData, 'user_id')

    setSubmitted(true);
    setTimeout(() => {
      setFormData({
        type: 'general',
        name: '',
        email: '',
        phone: '',
        message: '',
      });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="contact-form">
      <h3>{t('contact.form.title')}</h3>

      {submitted ? (
        <div className="form-success">
          <p>{t('contact.form.successMessage')}</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('contact.form.type')}</label>
            <select name="type" value={formData.type} onChange={handleChange}>
              <option value="donation">{t('contact.form.types.donation')}</option>
              <option value="partnership">{t('contact.form.types.partnership')}</option>
              <option value="general">{t('contact.form.types.general')}</option>
            </select>
          </div>

          <div className="form-group">
            <label>{t('contact.form.name')}</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>{t('contact.form.email')}</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>{t('contact.form.phone')}</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>{t('contact.form.message')}</label>
            <textarea
              name="message"
              rows="6"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="submit-btn">
            <FontAwesomeIcon icon={faPaperPlane} /> {t('contact.form.submit')}
          </button>
        </form>
      )}
    </div>
  );
};

export default ContactForm;
